import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import '../../css/actions.css';
import ConfigIntegration from '../../integrations/ConfigIntegration';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { DataTable } from 'primereact/datatable';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { EnvContext } from '../Context/EnvProvider';
import { useAuthToken } from '../../hooks/useAuthToken';

const configIntegration = new ConfigIntegration();

const Actions = ({ templateId, configs, setConfigs }) => {

    let emptyContext = {
        currentIntent: '',
        intentAction: '',
        url: '',
        method: '',
        smartEntities: '',
        payload: '',
        errorAction: 'textToUser',
        errorMessage: '',
        username: '',
        password: '',
        nextIntents: []
    };

    const [intents, setIntents] = useState();
    const [actions, setActions] = useState();
    const [configDialog, setConfigDialog] = useState(false);
    const [deleteConfigDialog, setDeleteConfigDialog] = useState(false);
    const [config, setConfig] = useState(emptyContext);
    const [selectedConfigs, setSelectedConfigs] = useState(null);
    const [loading, setLoading] = useState(true);
    const toast = useRef(null);
    const dt = useRef(null);
    const { getAccessToken } = useAuthToken();

    const { environment } = useContext(EnvContext);

    useEffect(() => {
        setConfigs([]);
        if (templateId) {
            const loadData = async () => {
                try {
                    const authToken = await getAccessToken();

                    const data = await configIntegration.getConfig(environment.botApi, templateId, authToken);
                    if (data && data.intentsConfig) {
                        setConfigs(data.intentsConfig);
                    }
                    await configIntegration.getTemplateName(environment.botApi, templateId, authToken);
                    const intentsData = await configIntegration.getIntents(environment.conversationApi, templateId, authToken);
                    setIntents(intentsData);
                    const actionsData = await configIntegration.getActions();
                    setActions(actionsData);
                    setLoading(false);
                } catch (error) {
                    console.error(error);
                    setLoading(false);
                    toast.current?.show({
                        severity: 'error',
                        summary: 'Erro!',
                        detail: 'Erro ao carregar ações.',
                        life: 5000,
                    });
                }
            };
            
            loadData();
        }
    }, [environment.botApi, environment.conversationApi, getAccessToken, setConfigs, templateId]); 

    const findAction = (label) => {
        for (let index = 0; index < actions.length; index++) {
            const action = actions[index];
            if (action.items) {
                for (let index2 = 0; index2 < action.items.length; index2++) {
                    const item = action.items[index2];
                    if (item.label === label) {
                        return item;
                    }
                }
            }
        }
        //not found
        return null;
    }

    const openNew = () => {
        setConfig(emptyContext);
        setConfigDialog(true);
    }

    const hideDialog = () => {
        setConfigDialog(false);
    }

    const hidedeleteConfigDialog = () => {
        setDeleteConfigDialog(false);
    }

    const saveConfig = () => {
        const intentName = config.currentIntent;

        if (intentName) {
            let _configs = [...configs];
            let _config = { ...config };
            const index = findByIntentName(intentName);
            if (index >= 0) {
                _configs[index] = _config;
                toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: 'Ação Atualizada', life: 3000 });
            } else {
                // _config.id = createId();
                _configs.push(_config);
                toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: 'Ação Criada', life: 3000 });
            }

            setConfigs(_configs);
            setConfigDialog(false);
        }
    }

    const editConfig = (config) => {
        setConfig({ ...config });
        setConfigDialog(true);
    }

    const confirmDeleteConfig = (config) => {
        setConfig(config);
        setDeleteConfigDialog(true);
    }

    const deleteConfig = () => {
        let _configs = configs.filter(val => val.currentIntent !== config.currentIntent);
        setConfigs(_configs);
        setDeleteConfigDialog(false);
        setConfig(emptyContext);
        toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: 'Ação Deletada!', life: 3000 });
    }

    const findByIntentName = (intentName) => {
        let index = -1;
        for (let i = 0; i < configs.length; i++) {
            if (configs[i].currentIntent === intentName) {
                index = i;
                break;
            }
        }

        return index;
    }


    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _config = { ...config };
        _config[`${name}`] = val;
        if (name === "intentAction") {
            let foundAction = findAction(val);
            if (foundAction) {
                //RAFAEL: se encontrar então colocar as configurações no campo
                _config.url = foundAction.url;
                _config.method = foundAction.method;
                _config.payload = foundAction.payload;
                _config.smartEntities = foundAction.smartEntities;
                _config.username = foundAction.username;
                _config.password = foundAction.password;
            }
        }
        setConfig(_config);
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Novo" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const configBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => editConfig(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDeleteConfig(rowData)} />
            </React.Fragment>
        );
    }

    const configDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" icon="pi pi-check" className="p-button-text" onClick={saveConfig} />
        </React.Fragment>
    );
    const deleteconfigDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteConfigDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteConfig} />
        </React.Fragment>
    );

    return (
        <div className="configs">
            <Toast ref={toast} />

            <div className="card">
                <Toolbar className="p-mb-4" left={leftToolbarTemplate}></Toolbar>

                <DataTable ref={dt} value={configs} selection={selectedConfigs} onSelectionChange={(e) => setSelectedConfigs(e.value)}
                    dataKey="id"
                    responsiveLayout="scroll"
                    loading={loading}>
                    <Column field="currentIntent" header="Nome da Intent" sortable style={{ minWidth: '16rem' }}></Column>
                    <Column field="intentAction" header="Ação" sortable style={{ minWidth: '12rem' }}></Column>
                    <Column field="errorAction" header="Caso de Falha" sortable style={{ minWidth: '12rem' }}></Column>
                    <Column field="errorMessage" header="Mensagem ou Evento" sortable style={{ minWidth: '16rem' }}></Column>
                    <Column body={configBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
                </DataTable>
            </div>

            <Dialog visible={configDialog} style={{ width: '800px' }} header="Configuração avançada da intent" modal className="p-fluid" footer={configDialogFooter} onHide={hideDialog}>
                <div className="p-field">
                    <label htmlFor="config">Seleciona a Intent:</label>
                    <span className="p-float-label">
                        <Dropdown
                            value={config.currentIntent}
                            options={intents}
                            onChange={(e) => onInputChange(e, 'currentIntent')}
                            placeholder="Intent"
                            id="intent"
                        >
                        </Dropdown >
                    </span>
                </div>

                <div>
                    <h4>Configuração de ação:</h4>
                </div>
                <div className="p-fluid p-grid">
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="action">Seleciona a Ação:</label>
                        <span className="p-float-label">
                            <Dropdown
                                placeholder="Ação"
                                value={config.intentAction}
                                options={actions}
                                onChange={(e) => onInputChange(e, 'intentAction')}
                                optionLabel="label"
                                optionGroupLabel="label"
                                optionGroupChildren="items"
                                id="action"
                            >
                            </Dropdown>
                        </span>
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="url">URL:</label>
                        <InputText id="url" value={config.url} onChange={(e) => onInputChange(e, 'url')} />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="method">Método:</label>
                        <InputText id="method" value={config.method} onChange={(e) => onInputChange(e, 'method')} />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="smartEntities">Smart entities:</label>
                        <InputText id="smartEntities" value={config.smartEntities} onChange={(e) => onInputChange(e, 'smartEntities')} />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="username">Nome de Usuário:</label>
                        <InputText autoComplete="new-username" id="username" value={config.username} onChange={(e) => onInputChange(e, 'username')} />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="password">Senha:</label>
                        <InputText id="password" value={config.password} onChange={(e) => onInputChange(e, 'password')} />
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <label htmlFor="payload">Payload:</label>
                        <InputTextarea id="payload" value={config.payload} onChange={(e) => onInputChange(e, 'payload')} rows={4} />
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <label htmlFor="conditions">Conditions (key-value-event;key-value-event):</label>
                        <InputTextarea id="conditions" value={config.conditions} onChange={(e) => onInputChange(e, 'conditions')} rows={4} />
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <h4>Em caso de erro na ação:</h4>
                    </div>
                    <div className="p-field-radiobutton p-col-12 p-md-5">
                        <RadioButton inputId="textToUser" name="config.errorAction" value="textToUser" onChange={(e) => onInputChange(e, 'errorAction')} checked={config.errorAction === 'textToUser'} />
                        <label htmlFor="textToUser">Mensagem para Usuário</label>
                    </div>
                    <div className="p-field-radiobutton p-col-12 p-md-5">
                        <RadioButton inputId="textToBot" name="config.errorAction" value="textToBot" onChange={(e) => onInputChange(e, 'errorAction')} checked={config.errorAction === 'textToBot'} />
                        <label htmlFor="textToBot">Mensagem para o bot</label>
                    </div>
                    <div className="p-field-radiobutton p-col-12 p-md-2">
                        <RadioButton inputId="event" name="config.errorAction" value="event" onChange={(e) => onInputChange(e, 'errorAction')} checked={config.errorAction === 'event'} />
                        <label htmlFor="event">Evento</label>
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <label htmlFor="message">Mensagem ou Evento</label>
                        <InputText id="message" value={config.errorMessage} onChange={(e) => onInputChange(e, 'errorMessage')} />
                    </div>
                    <div>
                        <h4>Validação fluxo:</h4>
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <span className="p-float-label">
                            <MultiSelect
                                value={config.nextIntents}
                                options={intents}
                                inputId="nextIntents"
                                onChange={(e) => onInputChange(e, 'nextIntents')}
                                placeholder="Proximas Intents permitidas"
                                optionLabel="label"
                                display="chip"
                            >

                            </MultiSelect>
                            <label htmlFor="nextIntents">Proximas Intents permitidas</label>
                        </span>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={deleteConfigDialog} style={{ width: '450px' }} header="Confirme" modal footer={deleteconfigDialogFooter} onHide={hidedeleteConfigDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {config && <span>Tem certeza de que deseja excluir <b>{config.value}</b>?</span>}
                </div>
            </Dialog>
        </div>
    );
}

export default Actions;
